<div class="forgot-wrapper">
  <div class="forgot-card">
    <!-- icon -->
    <div class="icon-circle">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <path
          d="M17 9H7C5.89543 9 5 9.89543 5 11V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V11C19 9.89543 18.1046 9 17 9Z"
          stroke="#6A3DE8"
          stroke-width="1.8"
        />
        <path
          d="M8 9V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V9"
          stroke="#6A3DE8"
          stroke-width="1.8"
        />
      </svg>
    </div>

    <h2>Forgot Password?</h2>

    <p class="subtitle">Enter your email and we'll help you reset your password</p>

    <div class="form-group">
      <label>Email <span class="fp-required">*</span></label>
      <input
        type="email"
        [(ngModel)]="email"
        placeholder="you@example.com"
        (keydown.enter)="next()"
      />
    </div>

    @if (errorMessage) {
      <p class="error-msg">
        @if (showRegisterCta) {
          @for (part of errorParts; track part) {
            @if (part.isLink) {
              <a class="inline-link" (click)="goToRegister()">{{ part.text }}</a>
            } @else {
              {{ part.text }}
            }
          }
        } @else {
          {{ errorMessage }}
        }
      </p>
    }

    <button class="next-btn" (click)="next()" [disabled]="loading || !email.trim()">
      {{ loading ? 'Sending…' : 'Next →' }}
    </button>
  </div>
</div>
